export default __webpack_public_path__ + "static/media/b68.6347048b.png";